import {
  ROOM_GROUP_PREVIEW,
  ROOM_GROUP_NEW,
  ROOM_GROUP_UPDATE,
  ROOM_GROUP_REMOVE,
  ROOM_GROUP_PROCESS_SUCCESS,
  ROOM_GROUP_DATASOURCE_SUCCESS,
  ROOM_GROUP_SEARCH,
  ROOM_GROUP_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ROOM_GROUP_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case ROOM_GROUP_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case ROOM_GROUP_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case ROOM_GROUP_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case ROOM_GROUP_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case ROOM_GROUP_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case ROOM_GROUP_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case ROOM_GROUP_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}